import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("选品配置")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("推荐配置")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("黑名单配置")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("权重配置")
const _hoisted_10 = {
  class: "card-body",
  style: {"padding-top":"0px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "el-icon-picture-outline",
    style: {"font-size":"30px","line-height":"150px"}
  })
], -1)
const _hoisted_12 = { style: {"padding":"0 5px"} }
const _hoisted_13 = {
  key: 0,
  style: {"line-height":"25px","clear":"both"}
}
const _hoisted_14 = { style: {"float":"left","font-weight":"bold"} }
const _hoisted_15 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_16 = {
  key: 1,
  style: {"float":"right"}
}
const _hoisted_17 = {
  class: "row",
  style: {"margin-top":"10px"}
}
const _hoisted_18 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_19 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: 30 }, "30", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: 60 }, "60", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: 90 }, "90", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: 150 }, "150", -1)
const _hoisted_24 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_26 = { class: "dialog-footer" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("灰色栏位请联系商务进行开通")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle ms-2 fs-7" }, null, -1)
const _hoisted_32 = { class: "dialog-footer" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("灰色栏位请联系商务进行开通")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle ms-2 fs-7" }, null, -1)
const _hoisted_38 = { class: "dialog-footer" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("灰色栏位请联系商务进行开通")
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle ms-2 fs-7" }, null, -1)
const _hoisted_44 = { class: "dialog-footer" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }

import {MenuComponent} from "@/assets/ts/components";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import { useRoute, useRouter } from "vue-router";
import ApiService from "@/core/services/ApiService";
import { renderThousands } from '@/utils'
import { ElMessage, ElMessageBox } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const apiUrl = 'report/product';
const dataTable = ref<any[]>([]);
const dataField = ref<any[]>([]);
const filters = reactive({
  report_id: 0,  // 列表表头
  category: [] as string[],  // 类目
  params: {}, // 筛选项参数，格式field: value
  weekly: '',  // 周期，总共就8周
  source: '', // 来源
  goods_id: '', // newin的topn商品id
});
const config = reactive({
  config: {} as any,  //模块配置
  selection_enabled: false, //是否具有选品模块权限
  recommend_enabled: false, //是否具有推荐模块权限
});
const loading = ref<boolean>(false);
// 分页
const pagination = reactive({
  enable: true,
  page: 1,
  pageCount: 0,
  total: 0,
  rowsPerPage: 30,
});
// 选中的商品
const goodsIds = ref<any>([]);
// 四个弹层
const dialog = reactive({
  selection: false,
  recommend: false,
  black: false,
  weight: false,
});
// 表单配置载入
const dialoagLoading = ref<boolean>(false);
// 表单提交延迟
const btnLoading = ref<boolean>(false);
// 表单引用
const selectionFormRef = ref<HTMLElement | null>(null);
const recommendFormRef = ref<HTMLElement | null>(null);
const blackFormRef = ref<HTMLElement | null>(null);
const weightFormRef = ref<HTMLElement | null>(null);
// 弹框选项数据
const dialogData = reactive({
  page: [] as any[],
  category: [] as any[],
});
// 全选状态
const isIndeterminate = ref<boolean>(false);

// 选品模块提交参数
const selectionForm = reactive({
  id: 0,
  name: '',
  country_name: '',
  goods_count: 1000,  // 选品数量
  goods_sorting_key_id: '',  // 商品排序值id
  category_id: [] as any[],  // 类目id
  dimension: [] as any[],  // 用于组装Tree控件中的选中数据
  rules: [] as any[],  // 维度属性
  rule_type: 2,  // 规则排序类型, 1:个性化; 2:规则; 0:手动
  rule_sorting_key: '',  // 规则排序值，原始排序为n，自定义排序为c, n:2; c:2
  update_frequency: 1,  // 频率, 1:天; 2:周; 3:月; 0:手动
  black_input_type: 1,  // 黑名单手工输入方式, 1:直接输入；2:文件导入
  black: [] as any[],  // 黑名单商品
  topping_type: 1,  // 置顶类型, 1:强制推广; 2:柔性推广
  topping_input_type: 1,  // 置顶手工输入方式, 1:直接输入；2:文件导入
  topping: [] as any[],  // 置顶商品
  selection_type: 2,  // 选品类型, 1:智能选品; 2:手动定制
  input_type: 1,  // 手工输入方式, 1:直接输入; 2:文件导入
  goods: [] as any[],  // 手动指定商品
});
const selectionRules = {
  name: [
    { required: true, message: '请输入方案名称', trigger: 'blur' }
  ],
  country_name: [
    { required: true, message: '请选择国家区域', trigger: 'change' }
  ],
}

// 推广方案提交参数
const recommendForm = reactive({
  id: 0,
  name: '',
  page_id: 1,
  area: '',
  category_id: 0,
  selection_type: 2,
  goods_count: 100,
  sorting_key_id: 0,
  start_time: '',
  stop_time: '',
  dimension: [] as any[],
  rules: [] as any[],
  position_type: 1,
  initial: 1,
  interval: 1,
  recommend_type: 1,
  threshold: 100,
  input_type: 1,
  goods: [] as any[],
});
const recommend_start_stop_time = ref<any>([
  recommendForm.start_time,
  recommendForm.stop_time
]);
const recommendValidateStartStopTime = (rule, value, callback) => {
  if (recommend_start_stop_time.value == null) {
    recommend_start_stop_time.value = [
      recommendForm.start_time,
      recommendForm.stop_time
    ];
  }
  recommendForm.start_time = recommend_start_stop_time.value[0];
  recommendForm.stop_time = recommend_start_stop_time.value[1];
  if (recommendForm.start_time == '' || recommendForm.stop_time == '') {
    callback(new Error('请输入起止时间！'));
  } else if (recommendForm.stop_time <= recommendForm.start_time) {
    callback(new Error('结束时间必须晚于开始时间！'));
  }
  callback();
};
const recommendRules = {
  name: [
    { required: true, message: '请输入名称！', trigger: 'blur' },
  ],
  page_id: [
    { required: true, message: '请选择栏位', trigger: 'change' }
  ],
  category_id: [
    { required: true, message: '请选择类目', trigger: 'change' }
  ],
  start_stop_time: [
    { validator: recommendValidateStartStopTime, trigger: 'blur' },
  ],
};

// 黑名单提交参数
const blackForm = reactive({
  id: 0,
  name: '',
  page_id: 1,
  selection_type: 2,
  goods_count: 100,
  sorting_key_id: 0,
  black_list_type: 2,
  start_time: '',
  stop_time: '',
  dimension: [] as any[],
  rules: [] as any[],
  input_type: 1,
  goods: [] as any[],
});
const black_start_stop_time = ref<any>([
  blackForm.start_time,
  blackForm.stop_time
]);
const blackValidateStartStopTime = (rule, value, callback) => {
  if (black_start_stop_time.value == null) {
    black_start_stop_time.value = [
      blackForm.start_time,
      blackForm.stop_time
    ];
  }
  blackForm.start_time = black_start_stop_time.value[0];
  blackForm.stop_time = black_start_stop_time.value[1];
  if (blackForm.start_time == '' || blackForm.stop_time == '') {
    callback(new Error('请输入起止时间！'));
  } else if (blackForm.stop_time <= blackForm.start_time) {
    callback(new Error('结束时间必须晚于开始时间！'));
  }
  callback();
};
const blackRules = {
  name: [
    { required: true, message: '请输入名称！', trigger: 'blur' },
  ],
  page_id: [
    { required: true, message: '请选择栏位', trigger: 'change' }
  ],
  start_stop_time: [
    { validator: blackValidateStartStopTime, trigger: 'blur' },
  ],
};

// 权重提交参数
const weightForm = reactive({
  id: 0,
  name: '',
  page_id: 1,
  weight: 1,
  pool_type: 2,
  goods_count: 100,
  sorting_key_id: 0,
  start_time: '',
  stop_time: '',
  dimension: [] as any[],
  rules: [] as any[],
  input_type: 1,
  goods: [] as any[],
});
const weight_start_stop_time = ref<any>([
  weightForm.start_time,
  weightForm.stop_time
]);
const weightValidateStartStopTime = (rule, value, callback) => {
  if (weight_start_stop_time.value == null) {
    weight_start_stop_time.value = [
      weightForm.start_time,
      weightForm.stop_time
    ];
  }
  weightForm.start_time = weight_start_stop_time.value[0];
  weightForm.stop_time = weight_start_stop_time.value[1];
  if (weightForm.start_time == '' || weightForm.stop_time == '') {
    callback(new Error('请输入起止时间！'));
  } else if (weightForm.stop_time <= weightForm.start_time) {
    callback(new Error('结束时间必须晚于开始时间！'));
  }
  callback();
};
const weightRules = {
  name: [
    { required: true, message: '请输入名称！', trigger: 'blur' },
  ],
  page_id: [
    { required: true, message: '请选择栏位', trigger: 'change' }
  ],
  start_stop_time: [
    { validator: weightValidateStartStopTime, trigger: 'blur' },
  ],
};

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("report.product.productList", ["report.product.name", "report.product.productName"]);

  ApiService.get(apiUrl + '/config').then(({data}) => {
    config.config = data.config;
    config.selection_enabled = data.selection_enabled;
    config.recommend_enabled = data.recommend_enabled;
  });

  let params = route.query;
  if (params['params'] != undefined) params['params'] = JSON.parse(params['params'] as string);
  for (let p in filters) {
    if (params[p] != undefined) {
      if (p === 'params' && params['params']) {
        for (let f in params['params'] as any) {
          filters['params'][f] = params['params'][f];
        }
      } else if (p === 'category') {
        if (params['category'] === '') filters['category'] = [];
        else if (typeof(params['category']) == 'string') filters['category'] = [params['category']] as string[];
        else filters['category'] = params['category'] as string[];
      } else {
        filters[p] = params[p];
      }
    }
  }

  searchAction();
});

const searchAction = () => {
  let p = Object.assign(filters, {
    offset: pagination.rowsPerPage * (pagination.page -1),
    limit: pagination.rowsPerPage,
    page: pagination.page
  })
  loading.value = true;
  ApiService.get(apiUrl, p).then(({data}) => {
    pagination.total = data.count;
    pagination.pageCount = Math.ceil(pagination.total / pagination.rowsPerPage);
    dataTable.value = data.results;
    dataField.value = data.fields;
    loading.value = false;
  });
}

const getTitle = () => {
  if (filters.source === 'category') {
    return filters.category.length === 0 ? '类目' : (filters.category.join('_') + (filters.weekly ? '_' + filters.weekly : ''));
  } else if (filters.source === 'topn') {
    return 'TOP N' + (filters.weekly ? '_' + filters.weekly : '');
  } else {
    let title = {
      10: '畅销款',
      11: '潜力款',
      12: '待优化细节款',
      13: '待优化主图款',
      14: '建议处理款',
      15: '曝光不足款',
    };
    return title[filters.report_id] + ' ' + filters.weekly;
  }
}

// 分页组件的设置第几页
const setCurrent = (val) => {
  pagination.page = val;
  searchAction()
}
// 设置分页数
const sizeChange = (val) => {
  pagination.rowsPerPage = parseInt(val.target.value);
  searchAction()
}

// 选中/取消选中动作
const changeChecked = (val) => {
  isIndeterminate.value = goodsIds.value.length > 0 && goodsIds.value.length < dataTable.value.length;
}
// 全选/取消全选动作
const checkAll = (val) => {
  goodsIds.value = [];
  if (val) dataTable.value.map(item => {goodsIds.value.push(item.goods_id)});
  isIndeterminate.value = false;
}

// 选品弹层
const openSelection = () => {
  if (goodsIds.value.length < 1) {
    ElMessage.warning("请先选择商品！");
    return false;
  }
  selectionForm.goods = [];
  for (let id of goodsIds.value) {
    selectionForm.goods.push({goods_id: id});
  }
  dialoagLoading.value = true;
  ApiService.get('programme/config').then(({data}) => {
    if (data.area.length < 1) {
      ElMessage.error('选品模块未开通或基础数据不足，请与管理员联系！');
    } else {
      selectionForm.country_name = data.area[0].name;
      selectionForm.goods_sorting_key_id = data.goods_sorting_key[0].key_id;
      selectionForm.rule_sorting_key = data.rule_sorting_key[0].key_type + ':' + data.rule_sorting_key[0].key_id;
    }
    dialoagLoading.value = false;
  })
  dialog.selection = true;
}
// 选品配置提交
const submitSelection = () => {
  btnLoading.value = true;
  (selectionFormRef as any).value.validate((valid) => {
    if (valid) {
      ApiService.post('programme', selectionForm).then(() => {
        ElMessage.success("创建成功！");
        btnLoading.value = false;
        dialog.selection = false;
        setTimeout(() => {
          router.push({ name: "selection.my" });
        }, 2000);
      }).catch(()=>{
        btnLoading.value = false
      });
    } else {
      btnLoading.value = false
      return false
    }
  })
}

// 推广方案弹层
const openRecommend = () => {
  if (goodsIds.value.length < 1) {
    ElMessage.warning("请先选择商品！");
    return false;
  }
  recommendForm.goods = [];
  let i = 0;
  for (let id of goodsIds.value) {
    i += 1;
    recommendForm.goods.push({goods_id: id, position: i});
  }
  dialoagLoading.value = true;
  ApiService.get('recommend/programme/config').then(({data}) => {
    if (data.page.length < 1) {
      ElMessage.error('推荐模块未开通或基础数据不足，请与管理员联系！');
    } else {
      dialogData.page = [...data.page];
      if (!dialogData.page.some((p) => {return p.is_active == true})) {
        ElMessage.error('推荐模块未开通或基础数据不足，请与管理员联系！');
      }
      changePage(recommendForm.page_id);
    }
    dialoagLoading.value = false;
  });
  dialog.recommend = true;
}
const changePage = function(val) {
  if (val) {
    let page = dialogData.page.find((p) => {
      return p.id == val;
    });
    recommendForm.threshold = page.threshold_limit;
    let _categoryTree = (category) => {
      let tree: Array<any> = []
      for (let c of category) {
        let t = {
          label: c.category_name,
          value: c.category_id,
        }
        if (c.children) {
          t['children'] = _categoryTree(c.children)
        }
        tree.push(t)
      }
      return tree
    }
    ApiService.get( 'recommend/programme/category', {page: val}).then(({data}) => {
      if (data.area.length < 1) {
        ElMessage.error('推荐模块未开通或基础数据不足，请与管理员联系！');
      } else {
        recommendForm.area = data.area[0].name;
        dialogData.category = _categoryTree(data.category);
        if (page.id == 1) {
          recommendForm.category_id = 0;
          dialogData.category = [];
        }
      }
    });
  }
};
// 推广方案配置提交
const submitRecommend = () => {
  btnLoading.value = true;
  (recommendFormRef as any).value.validate((valid) => {
    if (valid) {
      ApiService.post('recommend/programme', recommendForm).then(() => {
        ElMessage.success("创建成功！");
        btnLoading.value = false;
        dialog.recommend = false;
        setTimeout(() => {
          router.push({name: "recommend.programme"});
        }, 2000);
      }).catch(()=>{
        btnLoading.value = false
      });
    } else {
      btnLoading.value = false
      return false
    }
  })
}

// 黑名单弹层
const openBlack = () => {
  if (goodsIds.value.length < 1) {
    ElMessage.warning("请先选择商品！");
    return false;
  }
  blackForm.goods = [];
  for (let id of goodsIds.value) {
    blackForm.goods.push({goods_id: id});
  }
  dialoagLoading.value = true;
  ApiService.get('recommend/black/config').then(({data}) => {
    if (data.page.length < 1) {
      ElMessage.error('推荐模块未开通或基础数据不足，请与管理员联系！');
    } else {
      dialogData.page = [...data.page];
      if (!dialogData.page.some((p) => {return p.is_active == true})) {
        ElMessage.error('推荐模块未开通或基础数据不足，请与管理员联系！');
      }
    }
    dialoagLoading.value = false;
  });
  dialog.black = true;
}
// 黑名单配置提交
const submitBlack = () => {
  btnLoading.value = true;
  (blackFormRef as any).value.validate((valid) => {
    if (valid) {
      ApiService.post('recommend/black', blackForm).then(() => {
        ElMessage.success("创建成功！");
        btnLoading.value = false;
        dialog.black = false;
        setTimeout(() => {
          router.push({name: "recommend.blackPool"});
        }, 2000);
      }).catch(()=>{
        btnLoading.value = false
      });
    } else {
      btnLoading.value = false
      return false
    }
  })
}

// 权重弹层
const openWeight = () => {
  if (goodsIds.value.length < 1) {
    ElMessage.warning("请先选择商品！");
    return false;
  }
  weightForm.goods = [];
  for (let id of goodsIds.value) {
    weightForm.goods.push({goods_id: id, weight: 1});
  }
  dialoagLoading.value = true;
  ApiService.get('recommend/weight/config').then(({data}) => {
    if (data.page.length < 1) {
      ElMessage.error('推荐模块未开通或基础数据不足，请与管理员联系！');
    } else {
      dialogData.page = [...data.page];
      if (!dialogData.page.some((p) => {return p.is_active == true})) {
        ElMessage.error('推荐模块未开通或基础数据不足，请与管理员联系！');
      }
    }
    dialoagLoading.value = false;
  });
  dialog.weight = true;
}
// 权重配置提交
const submitWeight = () => {
  btnLoading.value = true;
  (weightFormRef as any).value.validate((valid) => {
    if (valid) {
      ApiService.post('recommend/weight', weightForm).then(() => {
        ElMessage.success("创建成功！");
        btnLoading.value = false;
        dialog.weight = false;
        setTimeout(() => {
          router.push({name: "recommend.weight"});
        }, 2000);
      }).catch(()=>{
        btnLoading.value = false
      });
    } else {
      btnLoading.value = false
      return false
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_page_header, {
          content: getTitle(),
          onBack: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        }, null, 8, ["content"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_checkbox, {
          indeterminate: isIndeterminate.value,
          onChange: checkAll,
          style: {"margin-right":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["indeterminate"]),
        (_unref(config).selection_enabled === true)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "mini",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openSelection()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(config).recommend_enabled === true)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              size: "mini",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openRecommend()))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(config).recommend_enabled === true)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              size: "mini",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (openBlack()))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(config).recommend_enabled === true)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              type: "primary",
              size: "mini",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (openWeight()))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: goodsIds.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((goodsIds).value = $event)),
        onChange: changeChecked,
        style: {"font-size":"13px"}
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTable.value, (v, i) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  key: i,
                  span: 4,
                  style: {"margin-bottom":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { "body-style": { padding: '5px', 'text-align': 'center' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {name: 'report.product.productSingle', query: {id: v.id}},
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_image, {
                              src: v.goods_img,
                              fit: "contain",
                              lazy: "",
                              style: {"height":"150px"}
                            }, {
                              error: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 2
                            }, 1032, ["src"])
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("div", _hoisted_12, [
                          (_unref(config).selection_enabled === true || _unref(config).recommend_enabled === true)
                            ? (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: 0,
                                label: v.goods_id
                              }, null, 8, ["label"]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataField.value, (f) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: f.id
                            }, [
                              (f.is_display)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(f.name), 1),
                                    (f.data_type === 2 || f.data_type === 3)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(renderThousands)(v[f.field])), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(v[f.field]), 1))
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })), [
            [_directive_loading, loading.value]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("select", {
                name: "kt_customers_table_length",
                class: "form-select form-select-sm form-select-solid",
                onChange: sizeChange,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(pagination).rowsPerPage) = $event))
              }, _hoisted_24, 544), [
                [_vModelSelect, _unref(pagination).rowsPerPage]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev, pager, next",
            onCurrentChange: setCurrent,
            "hide-on-single-page": true,
            "current-page": _unref(pagination).page,
            "page-size": _unref(pagination).rowsPerPage,
            total: _unref(pagination).total
          }, null, 8, ["current-page", "page-size", "total"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(dialog).selection,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(dialog).selection) = $event)),
      title: "选品方案便捷创建",
      width: "60%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_26, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(dialog).selection = false))
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (submitSelection())),
            disabled: btnLoading.value
          }, {
            default: _withCtx(() => [
              (!btnLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "确定"))
                : (_openBlock(), _createElementBlock("span", _hoisted_29, "请稍候"))
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "selectionFormRef",
          ref: selectionFormRef,
          model: _unref(selectionForm),
          rules: selectionRules,
          "label-width": "150px",
          style: {"margin-top":"-20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "方案名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(selectionForm).name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(selectionForm).name) = $event)),
                  placeholder: "请输入选择方案名称",
                  size: "small",
                  style: {"width":"300px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])), [
          [_directive_loading, dialoagLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(dialog).recommend,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(dialog).recommend) = $event)),
      title: "推广方案便捷创建",
      width: "60%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_32, [
          _createVNode(_component_el_button, {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(dialog).recommend = false))
          }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (submitRecommend())),
            disabled: btnLoading.value
          }, {
            default: _withCtx(() => [
              (!btnLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, "确定"))
                : (_openBlock(), _createElementBlock("span", _hoisted_35, "请稍候"))
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "recommendFormRef",
          ref: recommendFormRef,
          model: _unref(recommendForm),
          rules: recommendRules,
          "label-width": "150px",
          style: {"margin-top":"-20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(recommendForm).name,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(recommendForm).name) = $event)),
                  placeholder: "请填写商品推广配置名称",
                  size: "small",
                  style: {"width":"400px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "栏位",
              prop: "page_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(recommendForm).page_id,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(recommendForm).page_id) = $event)),
                  placeholder: "请选择栏位页",
                  size: "small",
                  onChange: changePage
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialogData).page, (v) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        value: v.id,
                        key: v.id,
                        label: v.name,
                        disabled: !v.is_active
                      }, null, 8, ["value", "label", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_tooltip, {
                  effect: "light",
                  placement: "right"
                }, {
                  content: _withCtx(() => [
                    _hoisted_30
                  ]),
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(dialogData).category.length > 0)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "商品类目",
                  prop: "category_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_cascader, {
                      modelValue: _unref(recommendForm).category_id,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(recommendForm).category_id) = $event)),
                      options: _unref(dialogData).category,
                      props: { checkStrictly: true, emitPath: false },
                      placeholder: "请选择类目",
                      size: "small",
                      "collapse-tags": "",
                      style: {"width":"400px"}
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "起止时间",
              prop: "start_stop_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: recommend_start_stop_time.value,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((recommend_start_stop_time).value = $event)),
                  type: "datetimerange",
                  "range-separator": "到",
                  "value-format": "YYYY-MM-DD H:m:s",
                  size: "small",
                  "start-placeholder": "请输入开始时间",
                  "end-placeholder": "请输入结束时间",
                  clearable: false,
                  "append-to-body": false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])), [
          [_directive_loading, dialoagLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(dialog).black,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(dialog).black) = $event)),
      title: "黑名单便捷创建",
      width: "60%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_38, [
          _createVNode(_component_el_button, {
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_unref(dialog).black = false))
          }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (submitBlack())),
            disabled: btnLoading.value
          }, {
            default: _withCtx(() => [
              (!btnLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_40, "确定"))
                : (_openBlock(), _createElementBlock("span", _hoisted_41, "请稍候"))
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "blackFormRef",
          ref: blackFormRef,
          model: _unref(blackForm),
          rules: blackRules,
          "label-width": "150px",
          style: {"margin-top":"-20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(blackForm).name,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(blackForm).name) = $event)),
                  placeholder: "请填写黑名单商品池名称",
                  size: "small",
                  style: {"width":"400px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "栏位",
              prop: "page_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(blackForm).page_id,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(blackForm).page_id) = $event)),
                  placeholder: "请选择栏位页",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialogData).page, (v) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        value: v.id,
                        key: v.id,
                        label: v.name,
                        disabled: !v.is_active
                      }, null, 8, ["value", "label", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_tooltip, {
                  effect: "light",
                  placement: "right"
                }, {
                  content: _withCtx(() => [
                    _hoisted_36
                  ]),
                  default: _withCtx(() => [
                    _hoisted_37
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "起止时间",
              prop: "start_stop_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: black_start_stop_time.value,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((black_start_stop_time).value = $event)),
                  type: "datetimerange",
                  "range-separator": "到",
                  "value-format": "YYYY-MM-DD H:m:s",
                  size: "small",
                  "start-placeholder": "请输入开始时间",
                  "end-placeholder": "请输入结束时间",
                  clearable: false,
                  "append-to-body": false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])), [
          [_directive_loading, dialoagLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(dialog).weight,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(dialog).weight) = $event)),
      title: "权重便捷创建",
      width: "60%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_44, [
          _createVNode(_component_el_button, {
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_unref(dialog).weight = false))
          }, {
            default: _withCtx(() => [
              _hoisted_45
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (submitWeight())),
            disabled: btnLoading.value
          }, {
            default: _withCtx(() => [
              (!btnLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_46, "确定"))
                : (_openBlock(), _createElementBlock("span", _hoisted_47, "请稍候"))
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "weightFormRef",
          ref: weightFormRef,
          model: _unref(weightForm),
          rules: weightRules,
          "label-width": "150px",
          style: {"margin-top":"-20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(weightForm).name,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(weightForm).name) = $event)),
                  placeholder: "请填写权重商池配置名称",
                  size: "small",
                  style: {"width":"400px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "栏位",
              prop: "page_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(weightForm).page_id,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(weightForm).page_id) = $event)),
                  placeholder: "请选择栏位页",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dialogData).page, (v) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        value: v.id,
                        key: v.id,
                        label: v.name,
                        disabled: !v.is_active
                      }, null, 8, ["value", "label", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_tooltip, {
                  effect: "light",
                  placement: "right"
                }, {
                  content: _withCtx(() => [
                    _hoisted_42
                  ]),
                  default: _withCtx(() => [
                    _hoisted_43
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "起止时间",
              prop: "start_stop_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: weight_start_stop_time.value,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((weight_start_stop_time).value = $event)),
                  type: "datetimerange",
                  "range-separator": "到",
                  "value-format": "YYYY-MM-DD H:m:s",
                  size: "small",
                  "start-placeholder": "请输入开始时间",
                  "end-placeholder": "请输入结束时间",
                  clearable: false,
                  "append-to-body": false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])), [
          [_directive_loading, dialoagLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})